export function getHeaderName (type) {
    const headers = {
        marketing_brochures: "Marketing Brochures",
        marketing_events: "Marketing Events",
        industrynews: "News Room",
        marketing_insights: "Insights",
        marketing_videos: "Videos",
        podcasts: "Podcasts",
        marketing_awards: "Awards & Recognition",
        solutions: "Solutions",
        solutions_recommended_media: "Solutions - Recommended Media",
        "solution_authors": "Solutions - Authors",
    };
    return headers[type] || "Others";
  };
  